<template>
  <div id="main" v-if="selectedCounty != null">
    <div class="name"> {{ selectedCounty.BU_NAAM }} </div>
      <div class="attribute"> {{ selectedXAttribute.label[this.currentLanguage] }} </div>
      <div class="value"> {{ getValueForAttribute(selectedCounty, this.selectedXAttribute) }} </div>
      <span v-if="this.selectedYAttribute != null"> | </span>
      <div class="attribute" v-if="this.selectedYAttribute != null"> {{ this.selectedYAttribute.label[this.currentLanguage] }} </div>
      <div class="value" v-if="this.selectedYAttribute != null"> {{ getValueForAttribute(selectedCounty, this.selectedYAttribute) }} </div>
  </div>
</template>

<style scoped>
  #main {
    flex: 1 1 auto;
    display: flex;
    flex-direction: row;
    align-items: baseline;
  }
  .name {
    font-size: 16pt;
    font-weight: bold;
  }
  .attribute {
    font-size: 10pt;
    margin-left: 10px;
  }
  .value {
    font-size: 10pt;
    margin-left: 5px;
    margin-right: 10px;
    font-weight: bold;
  }

</style>

<script>
  export default {
    data: () => ({
      unknownValue: -99999999,
      unknownLabel: {"EN": "unknown", "NL": "onbekend"}
    }),
    computed: {
      data() {
        return this.$store.getters.data;
      },
      idSelectedCounty() {
        return this.$store.getters.idSelectedCounty;
      },
      selectedCounty() {
        return this.data.find(d => d.BU_CODE == this.idSelectedCounty);
      },
      attributes() {
        return this.$store.getters.attributes;
      },
      currentLanguage() {
        return this.$store.getters.currentLanguage;
      },
      selectedXAttribute() {
        return this.$store.getters.selectedXAttribute;
      },
      selectedYAttribute() {
        return this.$store.getters.selectedYAttribute;
      }
    },
    methods: {
      getValueForAttribute(county, attribute) {
        let value = county[attribute.id];
        if (value == this.unknownValue) {
          value = this.unknownLabel[this.currentLanguage];
        } else {
          //value = parseFloat(value).toFixed(2);
        }
        return value;
      }
    }
  }
</script>
